/* eslint-disable no-debugger */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-globals */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable react/jsx-boolean-value */
import React, {
    useState, useContext, useEffect, useCallback,
} from 'react';
import {
    useLocation,
    Link,
} from 'react-router-dom';
import { motion } from 'framer-motion';
import ReactSlidingPane from 'react-sliding-pane';
import TableHeader from '../../../TableHeader';
import HeaderContext from '../../../Components/Context/HeaderContext';
import Pagination from '../../../Components/Pagination';
import EmptyScreen from '../../../Components/GlobalEmplyPage';
import ItemSkeleton from '../../../Components/Skeletons/itemSkeleton';
import ApprovedOrderList from './approvedOrderList';
import { distributorService } from '../../../service/distributor.service';
import FilterModal from './FilterModal';
import CreateDirectOrderPopup from '../Components/CreateDirectOrderModal';
import { userService } from '../../../service/user.service';
import { AccessPrevilegesFunction } from '../../../constants/GlobalAccessFunction';
import CancelOrderModal from '../../ManagerOrders/Components/CancelOrderModal';
import CustomToast from '../../../Components/AlertPopup';

function ManageApprovedOrders() {
    const [isPaneOpen, setisPaneOpen] = useState(false);
    const [NoUser, setNoUser] = useState(false);
    const [showSuccess, setshowSuccess] = useState(false);
    const [isLoaded, setisLoaded] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState('');
    const [EditDAte, setEditDAte] = useState([]);
    const [editpaneopen, seteditpaneopen] = useState(false);
    const [title, settitle] = useState(' Otp Verification Successful!');
    const [sort, setsort] = useState(false);
    const [sortType, setsortType] = useState('created_at+desc');
    const [alertShow, setalertShow] = useState(false);
    const [linksentPopup, setlinksentPopup] = useState(false);
    const [searchValue, setsearchValue] = useState('');
    const [loading, setloading] = useState(false);
    const [statusLoader, setstatusLoader] = useState('');
    const [nextPageHasData, setnextPageHasData] = useState(false);
    const [filter, setfilter] = useState(false);
    const [OpenPopup, setOpenPopup] = useState('');
    const [actvloader, setactvloader] = useState(false);
    const [showPopup, setshowPopup] = useState(false);
    const [renderPage, setrenderPage] = useState(false);
    const [render, setrender] = useState(false);
    const [filterValue, setfilterValue] = useState('');
    const [exportClick, setexportClick] = useState(false);
    const [isEditId, setisEditId] = useState('');
    const [alldata, setalldata] = useState({});
    const [orderList, setorderList] = useState([]);
    const [filterOpen, setfilterOpen] = useState(true);
    const [exportSelected, setexportSelected] = useState('');
    const [filterUrl, setfilterUrl] = useState('');
    const [directOrderPopup, setDirectOrderPopup] = useState(false);
    const [selected, setselected] = useState({
        start_date: '',
        end_date: '',
    });
    const [Filter, setFilter] = useState({
        order_type: [],
        order_status: [],
        type: [],
        order_category: [],
    });
    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
        HardRefresh,
        setHardRefresh,
        collapsed,
    } = useContext(HeaderContext);

    const handleFetch = useCallback(((url, clear) => {
        // const page = handlePageValue();
        setHardRefresh(false);
        let params = url || filterUrl;
        if (url) {
            setisLoaded(true);
            setCurrentPage(1);
        }
        if (params === '' || clear) {
            params = '&status=3,4,5,6,7,8,-1';
        }
        setfilterUrl(params);
        distributorService.ApprovalList(currentPage, sortType, searchValue, params).then((resp) => {
            if (resp?.data?.data?.Items.length > 0) {
                setnextPageHasData(true);
                setalldata(resp.data.data);
                setorderList(resp.data.data.Items);
                setNoUser(false);
                setisLoaded(false);
            } else {
                setNoUser(true);
                setisLoaded(false);
                setnextPageHasData(false);
                if (searchValue !== '' || params !== '') {
                    setorderList([]);
                    setalldata([]);
                }
                setisLoaded(false);
            }
            setfilter(false);
        });

        // setisLoaded(false);
    }), [currentPage, searchValue, filterValue, sortType]);

    const handlePageClick = async (data) => {
        setisLoaded(false);
        const page = data.selected + 1;
        setCurrentPage(page);
    };

    useEffect(() => {
        handleFetch();
    }, [handleFetch]);

    const handleExport = useCallback((() => {
        distributorService.ApprovalList(currentPage, sortType, searchValue, filterUrl, exportSelected).then((val) => {
            if (val.data.success_status) {
                setshowPopup(true);
                settitle(val.data.message);
                setexportClick(false);
                setexportSelected('');
                window.open(val.data.url, '_blank');
                setTimeout(() => {
                    settitle('');
                    setshowPopup(false);
                }, 2000);
            }
        });
    }), [exportSelected]);
    const [cancelLoader, setcancelLoader] = useState(false);
    const [OrderDetails, setOrderDetails] = useState({});
    // cancel order
    const handleCancel = useCallback(((resp) => {
        setcancelLoader(true);
        const body = {
            status: 'Rejected',
        };
        distributorService.OrderCancel(`${resp.distributor_id}/${resp.order_number}`, body).then((val) => {
            if (!val.error) {
                setshowPopup(true);
                settitle('Order cancelled successfully');
                setTimeout(() => {
                    settitle('');
                    setshowPopup(false);
                }, 2000);
                setcancelLoader(false);
                setOrderDetails({});
                handleFetch();
            }
        });
    }), []);

    const previlegeassigned = AccessPrevilegesFunction('orders:create_direct_order');

    useEffect(() => {
        if (exportSelected !== '') {
            handleExport();
        }
    }, [handleExport]);
    return (
        <>
            {showPopup && (
                <CustomToast
                    open
                    message={title}
                />
            )}

            <TableHeader
                setsearchValue={setsearchValue}
                searchValue={searchValue}
                filter={filter}
                setfilter={setfilter}
                setexportSelected={setexportSelected}
                exportClick={exportClick}
                exportSelected={exportSelected}
                setexportClick={setexportClick}
                setisEditId={setisEditId}
                list={orderList}
                setCurrentPage={setCurrentPage}
                NoAddButton
                directOrder={true}
                setDirectOrderPopup={setDirectOrderPopup}
                previlegeassigned={previlegeassigned}
            />
            {(!isLoaded && orderList.length === 0)
            && <EmptyScreen search="yes" text="No Orders" all={searchValue.length > 0 ? 'under searched term' : 'found'} />}
            {isLoaded ? <ItemSkeleton />
                : (
                    <div>
                        {!isLoaded && orderList.length > 0 && (
                            <div
                                className="overflow-auto sticky top-0 left-0 dropdown-menu pb-7 z-10"
                                style={{ height: 'calc(100vh - 298px)' }}
                            >
                                <table className="w-full table-auto relative">
                                    <motion.thead
                                        animate={{ opacity: 1, x: 0 }}
                                        initial={{ opacity: 0, x: -10 }}
                                        exit={{ opacity: 0, x: -10 }}
                                        transition={{ duration: 0.15 }}
                                        style={{ zIndex: '99', opacity: '1', transform: 'none' }}
                                        className="rounded-bl-lg rounded-tl-lg min-w-[158px] sticky top-0 left-0 bg-[#555259]"
                                    >
                                        <tr className="bg-[#555259] h-10">
                                            <th
                                                className="py-2.5 px-6 rounded-bl-lg rounded-tl-lg min-w-[171px] sticky top-0 left-0 bg-[#555259]"
                                                scope="col"
                                            >
                                                <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                    Order Number
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 px-7 min-w-[168px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                    Indent Number
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 px-7 min-w-[168px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                    Acceptance No
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 px-7 min-w-[200px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                    Order Created Date
                                                    <a href="#" className="pl-[5px]">
                                                        <motion.img
                                                            animate={{ rotate: sortType === 'created_at+asc' ? 180 : 0 }}
                                                            className={`${sortType === 'created_at+desc' ? 'image-rotate' : ''}`}
                                                            src="/images/sort.svg"
                                                            alt="icon"
                                                            data-testid="order_created_date"
                                                            onClick={() => {
                                                                if (sortType === 'created_at+asc') {
                                                                    setsortType('created_at+desc');
                                                                } else if (sortType === 'created_at+desc') {
                                                                    setsortType('created_at+asc');
                                                                } else {
                                                                    setsortType('created_at+asc');
                                                                }
                                                                setCurrentPage(1);
                                                                // setisLoaded(true);
                                                            }}
                                                        />
                                                    </a>
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 px-7 min-w-[150px] text-center flex justify-center items-center pt-4">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                    Order Type
                                                    <a href="#" className="pl-[5px]">
                                                        <motion.img
                                                            animate={{
                                                                rotate: sortType === 'order_type+asc' ? 180 : 0,
                                                            }}
                                                            // className={`${sortType === 'status' ? 'image-rotate' : ''}`}
                                                            src="/images/sort.svg"
                                                            alt="icon"
                                                            data-testid="order_type"
                                                            onClick={() => {
                                                                if (sortType === 'order_type+asc') {
                                                                    setsortType('order_type+desc');
                                                                } else if (sortType === 'order_0:00type+desc') {
                                                                    setsortType('order_type+asc');
                                                                } else {
                                                                    setsortType('order_type+asc');
                                                                }
                                                                setCurrentPage(1);
                                                                // setisLoaded(true);
                                                            }}
                                                        />
                                                    </a>
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 px-7 min-w-[160px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Total line Items
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 px-7 min-w-[188px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Order Status
                                                    <a href="#" className="pl-[5px]">
                                                        <motion.img
                                                            animate={{
                                                                rotate: sortType === 'status+asc' ? 180 : 0,
                                                            }}
                                                            // className={`${sortType === 'status' ? 'image-rotate' : ''}`}
                                                            src="/images/sort.svg"
                                                            alt="icon"
                                                            data-testid="order_status"
                                                            onClick={() => {
                                                                if (sortType === 'status+asc') {
                                                                    setsortType('status+desc');
                                                                } else if (sortType === 'status+desc') {
                                                                    setsortType('status+asc');
                                                                } else {
                                                                    setsortType('status+asc');
                                                                }
                                                                setCurrentPage(1);
                                                                // setisLoaded(true);
                                                            }}
                                                        />
                                                    </a>
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 px-7 min-w-[152px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-end justify-end">
                                                    Total Amount
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 px-7 min-w-[152px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                    Plant Name
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 px-7 min-w-[240px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                    Distributor/Customer Name
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 px-7 min-w-[208px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Type
                                                    <a href="#" className="pl-[5px]">
                                                        <motion.img
                                                            animate={{
                                                                rotate: sortType === 'distributor_type+asc' ? 180 : 0,
                                                            }}
                                                            // className={`${sortType === 'status' ? 'image-rotate' : ''}`}
                                                            src="/images/sort.svg"
                                                            alt="icon"
                                                            data-testid="type"
                                                            onClick={() => {
                                                                if (sortType === 'distributor_type+asc') {
                                                                    setsortType('distributor_type+desc');
                                                                } else if (sortType === 'distributor_type+desc') {
                                                                    setsortType('distributor_type+asc');
                                                                } else {
                                                                    setsortType('distributor_type+asc');
                                                                }
                                                                setCurrentPage(1);
                                                                // setisLoaded(true);
                                                            }}
                                                        />
                                                    </a>
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 px-7 min-w-[208px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Order Category
                                                </span>
                                            </th>
                                            {/* <th scope="col" className="py-2.5 px-7 min-w-[208px]">
                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                        Dispatch Lead Period
                                    </span>
                                </th>
                                <th scope="col" className="py-2.5 px-7 min-w-[212px]">
                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                        Expected Dispatch Date
                                    </span>
                                </th> */}
                                            <th scope="col" className="py-2.5 px-7 min-w-[208px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    WF Status
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 px-7 min-w-[152px] rounded-tr-lg rounded-br-lg sm:sticky top-0 right-0 bg-[#555259]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                    Actions
                                                </span>
                                            </th>
                                        </tr>
                                    </motion.thead>
                                    <ApprovedOrderList
                                        setisPaneOpen={setisPaneOpen}
                                        // getUserList={getDAPList}
                                        DAPList={orderList}
                                        setisLoaded={setisLoaded}
                                        currentPage={currentPage}
                                        totalPage={totalPage}
                                        setCurrentPage={setCurrentPage}
                                        setrender={setrender}
                                        setEditDAte={setEditDAte}
                                        render={render}
                                        seteditpaneopen={seteditpaneopen}
                                        EditDAte={EditDAte}
                                        // handleSort={handleSort}
                                        setsort={setsort}
                                        sort={sort}
                                        setsortType={setsortType}
                                        filter={filter}
                                        OpenPopup={OpenPopup}
                                        setOpenPopup={setOpenPopup}
                                        actvloader={actvloader}
                                        setactvloader={setactvloader}
                                        isEditId={isEditId}
                                        setisEditId={setisEditId}
                                        isLoaded={isLoaded}
                                        OrderDetails={OrderDetails}
                                        setOrderDetails={setOrderDetails}
                                    />

                                </table>

                            </div>

                        )}

                        { !isLoaded && orderList && orderList.length > 0 && (
                            <Pagination
                                handlePageClick={handlePageClick}
                                totalPage={alldata.number_of_pages}
                                List={alldata}
                                currentPage={currentPage}
                            />
                        )}
                    </div>
                )}
            {Object.keys(OrderDetails).length > 0 && (
                <CancelOrderModal
                    handleCancel={() => {
                        setcancelLoader(false);
                        setOrderDetails({});
                    }}
                    OrderDetails={OrderDetails}
                    threeDotsLoader={cancelLoader}
                    orderCancel={handleCancel}
                />
            )}

            <ReactSlidingPane
                from="right"
                isOpen={filter}
                width="30%"
                className="z-50"
                hideHeader
                closeIcon
                onRequestClose={() => setfilter(false)}
            >
                <FilterModal
                    close={setfilter}
                    setcurrentpage={setCurrentPage}
                    setFilter={setFilter}
                    Filter={Filter}
                    handleFetch={handleFetch}
                    setfilterUrl={setfilterUrl}
                    selected={selected}
                    setselected={setselected}
                />

            </ReactSlidingPane>
            {directOrderPopup && (
                <CreateDirectOrderPopup
                    directOrderPopup={directOrderPopup}
                    setDirectOrderPopup={setDirectOrderPopup}
                />
            ) }
        </>

    );
}

export default ManageApprovedOrders;
